import { useRouteError } from "react-router-dom";
import Button from "../Buttons/Button";
import { useEffect } from "react";
import styled from "styled-components";

const RetryFallback = (props: any) => {
  let error = useRouteError();
  console.error(error);
  useEffect(() => {
    setInterval(() => window.location.reload(), 3000);
  }, []);
  return (
    <RetryContainer>
      <h1>Fout opgetreden, pagina wordt ververst..</h1>
      <small>{String(error)}</small>
      <Button
        onClick={() => window.location.reload()}
        label="Verversen"
        color="green"
      />
    </RetryContainer>
  );
};

const RetryContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: center;
  align-self: center;
`;

export default RetryFallback;
